<template>
	<section class="view-onboarding-join" id="view-onboarding-join">
		<section class="graphic">
			<slot name="graphic:before"></slot>
			<img src="@/Asset/image/onboarding/onboarding-graphic-05.avif" alt="Onboarding Graphic" />
			<slot name="graphic:after"></slot>
		</section>

		<section class="content">
			<h2 class="title">Unlock your legacy</h2>
			<p class="large description">
				Earn badges, track activity, and
				<br />
				build your player profile.
			</p>
		</section>

		<section class="actions">
			<ViewUiButtonSkip v-on:skip="$emit('continue')" />
			<ViewUiButtonSignUp v-on:click.native="Handle_OnClickSignUp" />
		</section>
	</section>
</template>

<script lang="ts">
	import * as Service from '@/App/Service';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Onboarding
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewOnboardingJoin extends ViewBase {
		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnClickSignUp(): Promise<void> {
			// const location = await ChalkySticks.Utility.Geolocation.requestLocation();

			// // Setup the settings
			// this.$store.dispatch('settings/enableLocation', location === 'granted');

			// // If location was granted, start the service
			// if (location === 'granted') {
			// 	Service.Location.start();
			// }

			// Emit continue event to move to next step
			this.$emit('signup');
		}
	}
</script>

<style lang="scss">
	.view-onboarding-join {
		background-image: url('@/Asset/image/onboarding/onboarding-background-05.avif');

		.graphic img {
			border: 8px solid var(--chalky-blue);
		}
	}
</style>
